// extracted by mini-css-extract-plugin
export default {"remaining":"TabsPanel_remaining__+sGEw","completed":"TabsPanel_completed__QZPMO"};